"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_RUNTIME_ENV_DEFAULTS = void 0;
exports.mapSecretsToRuntimeEnv = mapSecretsToRuntimeEnv;
const clientEnvironmentConfig_1 = require("./clientEnvironmentConfig");
/**
 * Default fallback values when env.js fails to load or values are not configured.
 * All undefined by default - services only initialize when explicitly configured.
 */
exports.CLIENT_RUNTIME_ENV_DEFAULTS = {
    sentryDsn: undefined,
    highlightProjectId: undefined,
};
/**
 * Maps environment variables to runtime environment format.
 * Uses CLIENT_ENVIRONMENT_FIELDS as the mapping source.
 */
function mapSecretsToRuntimeEnv(secrets) {
    const result = {};
    for (const field of clientEnvironmentConfig_1.CLIENT_ENVIRONMENT_FIELDS) {
        const envValue = secrets[field.envVar];
        result[field.runtimeKey] = envValue ?? null;
    }
    return result;
}
//# sourceMappingURL=clientEnvironmentModel.js.map